<div class="flex gap-y-2 w-full justify-between items-center">
  Callback Page
  <auth-logout-button></auth-logout-button>
</div>

<div class="flex flex-nowrap gap-x-1 w-full border-t border-dashed pt-3 mt-3">
  <h3 class="font-bold">Authentication status:</h3>
  <span>{{ authStatus() }}</span>
</div>
<div class="flex flex-nowrap gap-x-1 w-full">
  <h3 class="font-bold">Auth0 is loading:</h3>
  <span>{{ isAuthLoading() }}</span>
</div>
<div class="flex flex-nowrap gap-x-1 w-full">
  <h3 class="font-bold">User name:</h3>
  <span>{{ userName() }}</span>
</div>
<div class="flex flex-nowrap gap-x-1 w-full">
  <h3 class="font-bold">User nickname:</h3>
  <span>{{ userNickname() }}</span>
</div>
<div class="flex flex-nowrap gap-x-1 w-full">
  <h3 class="font-bold">User name:</h3>
  <span>{{ userName() }}</span>
</div>
<div class="flex flex-nowrap gap-x-1 w-full">
  <h3 class="font-bold">User roles:</h3>
  <span>{{ userRoles() | json }}</span>
</div>
<div class="flex flex-col gap-x-1 w-full">
  <h3 class="font-bold">User tenants:</h3>
  @for(tenant of userTenants(); track tenant;) {
    <span><b>ID:</b> {{tenant.id}} - R1: {{tenant.r1}} - CDOS: {{tenant.cdos}}</span>
  }
</div>
<div class="flex flex-col w-full border-t border-dashed pt-3 mt-3 gap-y-1">
  <h3 class="font-bold">User data:</h3>
  <pre>{{ authUser() | json}}</pre>
</div>
